import lazyloadHelper from "@ng-mw/shared-react-components/lazyloadHelper"

const { WithSuspense: Julelotteri } = lazyloadHelper(
    () => import(/* webpackChunkName: "christmas" */ "./Julelotteri"),
)
const { WithSuspense: Kronelotteri } = lazyloadHelper(
    () => import(/* webpackChunkName: "kronelotteri" */ "./Kronelotteri"),
)

export { Julelotteri, Kronelotteri }
